const Routes = {
  SIGNUP: "signup",
  LOGIN: "login",
  FORGOT_PASSWORD: "forgotpassword",
  FORGOT_PASSWORD_SUBMIT: "forgotpasswordsubmit",
  RESET_PASSWORD: "resetpassword",
  RESET_PASSWORD_SUBMIT: "resetpasswordsubmit",
  ONBOARDING: "onboarding",
  AI_MARKETPLACE: "aimarketplace",
  SERVICE_DETAILS: "servicedetails",
  USER_PROFILE: "userprofile",
  GET_STARTED: "getstarted",
  AI_REQUEST_FORM: "airequestform",
  hash: {
    SERVICE_DEMO: "#demo",
  },
};

export default Routes;
